import { Checkbox, CheckboxGroup } from '@hopin-team/ui-checkbox';
import React, { SyntheticEvent } from 'react';

export const CheckOptions = ({
  checkedOptions,
  name,
  onChange,
  labelRenderer,
  options,
}: {
  checkedOptions: string[];
  name: string;
  onChange: (values: SyntheticEvent<HTMLInputElement>) => void;
  labelRenderer?: (label: string) => string;
  options: { label: string; icon?: React.ReactNode }[];
}) => {
  if (options.length === 0) {
    return null;
  }

  return (
    <CheckboxGroup px={2} my={2} legend={name} name={name}>
      {options.map(opt => (
        <Checkbox
          onChange={onChange}
          key={opt.label}
          label={labelRenderer?.(opt.label) || opt.label}
          value={opt.label}
          checked={checkedOptions.includes(opt.label)}
          pb={1}
          mx={1}
        >
          {opt.icon}
        </Checkbox>
      ))}
    </CheckboxGroup>
  );
};
